<template>
  <transition-group @enter="showDot" @leave="hideDot" tag="div" class="tiny-dot-matrix" :css="false">
    <span class="dot" v-show="matrixPattern[n - 1] === 1" :key="n" v-for="n in (numOfCols * numOfRow)" :style="getDotStyles(n)"></span>
  </transition-group>
</template>

<script>

export default {
  name: 'dotMatrix',
  props: ['cols', 'rows', 'pattern', 'dotsize', 'dotcolor', 'dotgap'],
  data () {
    return {
    }
  },
  computed: {
    numOfCols () {
      return this.cols
    },
    numOfRow () {
      return this.rows
    },
    matrixPattern () {
      return this.pattern
    },
    dotSize () {
      return this.dotsize
    }
  },
  methods: {
    getDotStyles (n) {
      let i = n - 1
      return {
        width: this.dotSize + 'px',
        height: this.dotSize + 'px',
        top: (Math.floor(i / this.numOfCols) * this.dotSize) + (Math.floor(i / this.numOfCols) * this.dotgap) + 'px',
        left: (i % this.numOfCols) * this.dotSize + (i % this.numOfCols * this.dotgap) + 'px',
        'box-shadow': 'rgba(' + this.dotcolor + ', .3)',
        'background-color': 'rgb(' + this.dotcolor + ')'
      }
    },
    showDot (el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 1,
        ease: Sine.easeInOut
      })
    },
    hideDot (el, done) {
      TweenMax.to(el, 0.2, {
        autoAlpha: 0,
        ease: Sine.easeInOut
      })
    }
  }
}
</script>

<style lang="scss">
  .tiny-dot-matrix {
    width: 48px;
    height: 42px;
    margin-left: -.7rem;
    margin-right: -.4rem;
    position: relative;
    display: inline-block;
    .dot {
      display: block;
      position: absolute;
      background-color: #2b3031;
      box-shadow: 0px 0px 0px 1px rgba(0, 0, 0, .3);
      border-radius: 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dotMatrix.vue